import * as Yup from "yup";
import {
  FIELD_REQUIRED,
  MDP_MUST_MATCH,
  MDP_CHARACTERS,
  MDP_MIN,
  MDP_MAX,
} from "../../../common/constants/validationErrors";

export const changePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(FIELD_REQUIRED),
  newPassword: Yup.string()
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/,
      MDP_CHARACTERS
    )
    .min(12, MDP_MIN)
    .max(25, MDP_MAX)
    .required(FIELD_REQUIRED),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("newPassword"), null],
      MDP_MUST_MATCH
    )
    .required(FIELD_REQUIRED),
});
